import {Traitify} from "traitify-widgets";

const traitify = new Traitify();
traitify.http.host = "/proxy";
traitify.http.version = null;

export default traitify;
